<template>
  <div class="tabbar">
    <div class="page-position" id="jzqTabbar"></div>
    <div class="tabbar-item" :class="{ active: Number(current) === 1 }">
      <router-link class="text" to="/judicialService/safeguard"
        >办理进度</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "tabbar",
  props: {
    current: {
      type: [Number, String],
      default: 1
    },
    returnService: {
      type: [Number, String],
      default: 0
    }
  },
  async beforeMount() {
    // 没有用户数据时，刷新页面，重新获取
    if (
      !(
        this.$store.getters.currentAuthUser.userName ||
        this.$store.getters.currentAuthUser.name
      )
    ) {
      let refreshRes = await loginOrRefresh();
      if (!refreshRes.success) {
        this.reload();
      }
    }
  },
  created() {
    if (
      this.$route.path.indexOf("/judicialService/introduce") === -1 ||
      this.returnService
    ) {
      this.$nextTick(() => {
        document.getElementById("jzqTabbar").scrollIntoView();
      });
    }
  }
};
</script>

<style scoped lang="less">
.page-position {
  width: 100%;
  position: absolute;
  top: -100px;
}
.tabbar {
  display: flex;
  position: absolute;
  top: -18px;
  left: 15px;
}
.tabbar-item {
  width: 164px;
  height: 50px;
  background: url("/images/judicialService/tabbar-bg.png") no-repeat center
    center;
  background-size: 100% 100%;
  text-align: center;
  line-height: 50px;
  padding-right: 14px;
  .text {
    width: 100%;
    height: 100%;
    display: block;
    font-size: 20px;
    line-height: 50px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #290202;
  }
  &.active {
    .text {
      color: rgba(236, 28, 28, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/judicialService/tabbar.vue